import { createSelector } from '@reduxjs/toolkit';
import { getSelectedNodesInAllFolders } from '../fileManager/selectors/selectors';
import { getShareID } from '../app/selectors';
import { RootSelector } from '../../models/rootSelector';
import { UserAccessRight } from '../../../general/model';
import { isNodeDownloadAllowed } from '../../../general/node';

export const getEnabled: RootSelector<boolean> = createSelector(
  [getSelectedNodesInAllFolders, getShareID],
  (allNodes, shareId) => {
    return (
      allNodes.length > 0 &&
      // Файлы под модерацией нельзя скачивать (в т.ч. bulk и через Google Drive),
      // решение принимает бэкенд флагом downloading_allowed (MYUA-16456).
      allNodes.every(isNodeDownloadAllowed) &&
      (shareId !== null || allNodes.every((node) => node.perms.includes(UserAccessRight.read)))
    );
  },
);
